import { EngineReportType } from '@navstation-portal/reporting/data-model/engine-reports';
import { ReportType } from '@navstation-portal/reporting/data-model/vessel-report';
import { IconNames } from '@navstation-portal/shared/data-model/ui';
import { MenuItem } from 'primeng/api';

export { EngineReportType };

export interface VisibilityMapping {
  label: string;
  nextLevel?: VisibilityMapping[];
}
export interface SideMenuItem extends MenuItem {
  internalOnly?: boolean;
  route?: string;
  icon?: string;
  createReportType?: ReportType;
  createEngineReportType?: EngineReportType;
  collapsedRoute?: string;
}
export const ShowCrewDashboardClient: VisibilityMapping[] = [
  { label: 'Crew Dashboard' },
];
export const ShowFromNavFleet: VisibilityMapping[] = [{ label: 'NavFleet' }];
export const REPORT_TYPE_MENU_LABELS: Record<string, string> = {
  [ReportType.Sea]: 'Sea Report',
  [ReportType.Port]: 'Port Report',
  [ReportType.Anchor]: 'Anchor/Drifting Report',
  [ReportType.Drifting]: 'Anchor/Drifting Report',
  [ReportType.Maneuvering]: 'Manoeuvering Report',
};

export const ALL_CREATE_MENU_LABELS = [
  'Port Report',
  'Sea Report',
  'Anchor/Drifting Report',
  'Manoeuvering Report',
];
export const ShowOnInternalOnly: VisibilityMapping[] = [
  {
    label: 'Offshore Reports',
    nextLevel: [
      {
        label: 'Edit Report in Progress',
      },
    ],
  },
  { label: 'Client Settings' },
  { label: 'Management' },
  {
    label: 'Vessel Settings',
    nextLevel: [{ label: 'Technical Specifications' }],
  },
  {
    label: 'My Settings',
    nextLevel: [
      { label: 'Password Reset' },
      { label: 'Users' },
      { label: 'Vessels & Models Setup' },
    ],
  },
  {
    label: 'Vessel Settings',
    nextLevel: [
      {
        label: 'Ship Settings',
        nextLevel: [
          { label: 'Vessel Information' },
          { label: 'Events' },
          { label: 'Email Alerts' },
        ],
      },
    ],
  },
];
export const ShowEditReportInProgress: VisibilityMapping[] = [
  {
    label: 'Vessel Reports',
    nextLevel: [
      {
        label: 'Edit Report in Progress',
      },
    ],
  },
];

export const ShowOnIncompleteVesselReportReg: VisibilityMapping[] = [
  {
    label: 'Vessel Reports',
    nextLevel: [
      {
        label: 'Edit Report in Progress',
      },
    ],
  },
];
export const ShowOnIncompleteVesselReportOffshore: VisibilityMapping[] = [
  {
    label: 'Offshore Reports',
    nextLevel: [
      {
        label: 'Edit Report in Progress',
      },
    ],
  },
];
export const HideOnAnyIncompleteVesselReport: VisibilityMapping[] = [
  {
    label: 'Vessel Reports',
    nextLevel: [
      {
        label: 'Create New Report',
      },
    ],
  },
];
export const ShowEditOffshoreReportInProgress: VisibilityMapping[] =
  ShowOnIncompleteVesselReportOffshore;

export const HideOnAnyIncompleteOffshoreReport: VisibilityMapping[] = [
  {
    label: 'Offshore Reports',
    nextLevel: [
      {
        label: 'Create New Offshore Report',
      },
    ],
  },
];
export const ShowEmissionsClient: VisibilityMapping[] = [
  { label: 'Engine Report' },
];
export const ShowOnIncompleteEngineReport: VisibilityMapping[] = [
  {
    label: 'Engine Report',
    nextLevel: [
      {
        label: 'Edit ME Report in Progress',
      },
    ],
  },
];
export const HideOnIncompleteEngineReport: VisibilityMapping[] = [
  {
    label: 'Engine Report',
    nextLevel: [
      {
        label: 'Create New Report',
      },
    ],
  },
];
export const ShowOnDieselElectricEngineReport: VisibilityMapping[] = [
  {
    label: 'Engine Report',
    nextLevel: [
      {
        label: 'Create New Report',
        nextLevel: [{ label: 'ME Performance' }],
      },
    ],
  },
];
export const HideOnDieselElectricEngineReport: VisibilityMapping[] = [
  {
    label: 'Engine Report',
    nextLevel: [
      {
        label: 'Create New Report',
        nextLevel: [{ label: 'PM Performance' }],
      },
    ],
  },
];
export const routes: SideMenuItem[] = [
  {
    label: 'Crew Dashboard',
    icon: IconNames.GaugeHigh,
    route: 'crew-dashboard',
    visible: true,
  },
  {
    id: 'vessel-reports',
    label: 'Vessel Reports',
    icon: IconNames.Ship,
    visible: false,
    collapsedRoute: 'vessel-reports',
    items: [
      {
        label: 'View Vessel Reports',
        route: 'vessel-reports',
      },
      {
        label: 'Edit Report in Progress',
        route: 'vessel-reports',
        visible: false,
      },
      {
        label: 'Create New Report',
        visible: true,
        items: [
          {
            label: 'Port Report',
            icon: IconNames.PenToSquare,
            createReportType: ReportType.Port,
          },
          {
            label: 'Sea Report',
            icon: IconNames.PenToSquare,
            createReportType: ReportType.Sea,
          },
          {
            label: 'Anchor/Drifting Report',
            icon: IconNames.PenToSquare,
            createReportType: ReportType.Anchor,
          },
          {
            label: 'Manoeuvering Report',
            icon: IconNames.PenToSquare,
            createReportType: ReportType.Maneuvering,
          },
        ],
      },
    ],
  },
  {
    id: 'offshore-reports',
    label: 'Offshore Reports',
    icon: IconNames.Ship,
    visible: false,
    collapsedRoute: 'offshore-reports/view-reports',
    items: [
      {
        label: 'View Offshore Reports',
        route: 'offshore-reports/view-reports',
      },
      {
        label: 'Edit Report in Progress',
        route: 'offshore-reports',
        visible: false,
      },
      {
        label: 'Create New Offshore Report',
        route: 'offshore-reports/new-report',
        visible: true,
      },
    ],
  },
  {
    id: 'engine-reports',
    label: 'Engine Report',
    icon: IconNames.Gears,
    route: 'engine-reports',
    visible: true,
    items: [
      {
        label: 'View Engine Reports',
        route: 'engine-reports',
      },
      {
        label: `Edit ME Report in Progress`,
        route: 'engine-reports',
        visible: false,
      },
      {
        label: 'Create New Report',
        route: 'engine-reports',
        visible: true,
        items: [
          {
            label: 'ME Performance',
            createEngineReportType: EngineReportType.MainEngine,
            icon: IconNames.PenToSquare,
            visible: true,
          },
          {
            label: 'PM Performance',
            route: 'engine-reports',
            icon: IconNames.PenToSquare,
            visible: false,
          },
          {
            label: 'AE Performance',
            createEngineReportType: EngineReportType.AuxiliaryEngine,
            icon: IconNames.PenToSquare,
          },
        ],
      },
    ],
  },
  {
    label: 'Vessel Settings',
    icon: IconNames.Sliders,
    collapsedRoute: 'vessel-settings/information',
    items: [
      {
        label: 'Ship Settings',
        expanded: true,
        items: [
          {
            label: 'Vessel Information',
            route: 'vessel-settings/information',
            internalOnly: true,
            icon: IconNames.PenToSquare,
          },
          {
            label: 'Events',
            route: 'vessel-settings/events',
            visible: false,
            internalOnly: true,
            icon: IconNames.PenToSquare,
          },
          {
            label: 'Email Alerts',
            route: 'vessel-settings/alerts',
            visible: false,
            internalOnly: true,
            icon: IconNames.PenToSquare,
          },
          {
            label: 'NPE',
            route: 'vessel-settings/npe',
            icon: IconNames.PenToSquare,
          },
          {
            label: 'Charter Party Baselines',
            route: 'vessel-settings/cpb',
            icon: IconNames.PenToSquare,
          },
        ],
      },
      {
        label: 'Technical Specifications',
        route: 'vessel-settings',
        visible: false,
        internalOnly: true,
        items: [
          {
            label: 'Engine Configuration',
            route: 'vessel-settings',
            icon: IconNames.PenToSquare,
          },
          {
            label: 'Flow Meter Configuration (Deprecated)',
            route: 'vessel-settings',
            icon: IconNames.PenToSquare,
          },
          {
            label: 'Flow Meter Configuration',
            route: 'vessel-settings',
            icon: IconNames.PenToSquare,
          },
          {
            label: 'Tank Capacity',
            route: 'vessel-settings',
            icon: IconNames.PenToSquare,
          },
          {
            label: 'Fuel & Emission Rates',
            route: 'vessel-settings',
            icon: IconNames.PenToSquare,
          },
          {
            label: 'Propeller Configuration',
            route: 'vessel-settings',
            icon: IconNames.PenToSquare,
          },
        ],
      },
    ],
  },
  {
    label: 'My Settings',
    route: 'user-settings',
    icon: IconNames.CircleUser,
    items: [
      {
        label: 'Password Reset',
        route: 'user-settings',
        visible: false,
        internalOnly: true,
      },
      {
        label: 'Email Notifications',
        route: 'user-settings',
      },
      {
        label: 'Users',
        route: 'user-settings',
        icon: IconNames.Key,
        visible: false,
        internalOnly: true,
      },
      {
        label: 'Vessels & Models Setup',
        route: 'user-settings',
        icon: IconNames.Key,
        visible: false,
        internalOnly: true,
      },
    ],
  },
  {
    label: 'Client Settings',
    route: 'client-settings',
    icon: IconNames.CircleUser,
    visible: true,
    internalOnly: true,
    items: [
      {
        label: 'Veslink Config',
        route: 'client-settings',
        icon: IconNames.PenToSquare,
      },
    ],
  },
  {
    label: 'NavFleet',
    command: () => {
      window.open('https://navfleet.navtor.com/', '_blank');
    },
    visible: false,
  },
  {
    label: 'Management',
    route: 'management',
    icon: IconNames.Sliders,
    visible: true,
    internalOnly: true,
    items: [
      {
        label: 'View Clients',
        route: 'management',
      },
      {
        label: 'View Users',
        route: 'management',
      },
      {
        label: 'View Vessels',
        route: 'management',
      },
    ],
  },
  {
    id: 'fuel-tanks',
    label: 'Fuel & Tanks',
    icon: IconNames.GasPump,
    visible: true,
    collapsedRoute: 'fuel-tanks/bunkers',
    items: [
      {
        label: 'Bunkers',
        route: 'fuel-tanks/bunkers',
      },
      {
        label: 'Tanks',
        route: 'fuel-tanks/tanks',
      },
      {
        label: 'Fuel Lineage',
        route: 'fuel-tanks/lineage',
        visible: false,
      },
      {
        label: 'Tank Operations',
        route: 'fuel-tanks/tank-operations',
      },
    ],
  },
];
